var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82281 2.87988C4.02752 2.87988 3.38281 3.52459 3.38281 4.31988V24.4799C3.38281 25.2752 4.02752 25.9199 4.82281 25.9199H24.9828C25.7781 25.9199 26.4228 25.2752 26.4228 24.4799V4.31988C26.4228 3.52459 25.7781 2.87988 24.9828 2.87988H4.82281Z",
    fill: "#56617B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6228 7.73988V4.31988H30.7428V7.73988H33.6228Z",
    fill: "#56617B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6228 21.0599V14.5799H30.7428V21.0599H33.6228Z",
    fill: "#56617B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6228 30.2399V27.1799H30.7428V30.2399H27.5028V33.1199H30.7428C32.3334 33.1199 33.6228 31.8305 33.6228 30.2399Z",
    fill: "#56617B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82281 33.1199H8.06281V30.2399H4.82281V33.1199Z",
    fill: "#56617B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5428 33.1199H21.0228V30.2399H14.5428V33.1199Z",
    fill: "#56617B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8826 15.7509C17.5951 14.9714 18.3533 14.2132 19.1327 14.5007L34.4614 20.1548C35.2864 20.4591 35.3171 21.6145 34.5095 21.9622L28.4583 24.5673C28.2297 24.6657 28.0475 24.8479 27.9491 25.0765L25.3441 31.1276C24.9964 31.9352 23.8409 31.9045 23.5367 31.0796L17.8826 15.7509Z",
    fill: "#818CA7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.3d53da9190bf47c131fec8bce1c4405f.svg";
export { ForwardRef as ReactComponent };